import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-height: calc(85vh - 50px);
  overflow: hidden;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  border-bottom: 1px solid #e0e0e0;
`;

export const Title = styled.h2`
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: #333;
`;

export const Content = styled.div`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 16px;
  gap: 16px;

  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }
  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;
    &:hover {
      background: #a1a1a1;
    }
  }
`;

export const InfoGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  padding: 12px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
`;

export const InfoItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const InfoLabel = styled.span`
  font-size: 0.75rem;
  font-weight: 500;
  color: #6c757d;
  text-transform: uppercase;
  letter-spacing: 0.3px;
`;

export const InfoValue = styled.span`
  font-size: 0.9rem;
  font-weight: 600;
  color: #333;
`;

export const SectionTitle = styled.h3`
  font-size: 1rem;
  font-weight: 600;
  color: #495057;
  margin: 0;
  padding-bottom: 8px;
  border-bottom: 1px solid #e9ecef;
`;

export const UserTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 0.85rem;

  th {
    background: #f0f0f0;
    font-weight: 600;
    padding: 8px;
    text-align: left;
    border-bottom: 2px solid #dee2e6;
    color: #495057;
  }

  td {
    padding: 6px 8px;
    border-bottom: 1px solid #f0f0f0;
    color: #333;
  }

  tr:hover {
    background: #f8f9fa;
  }
`;

export const TableContainer = styled.div`
  border: 1px solid #e9ecef;
  border-radius: 6px;
`;

export const SummaryGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 12px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
`;

export const SummaryRow = styled.div<{ isTotal?: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${({ isTotal }) => isTotal ? '8px 0 0' : '2px 0'};
  border-top: ${({ isTotal }) => isTotal ? '2px solid #333' : 'none'};
  margin-top: ${({ isTotal }) => isTotal ? '4px' : '0'};
`;

export const SummaryLabel = styled.span<{ isTotal?: boolean }>`
  font-size: ${({ isTotal }) => isTotal ? '1rem' : '0.875rem'};
  font-weight: ${({ isTotal }) => isTotal ? '700' : '500'};
  color: ${({ isTotal }) => isTotal ? '#333' : '#6c757d'};
`;

export const SummaryValue = styled.span<{ isTotal?: boolean }>`
  font-size: ${({ isTotal }) => isTotal ? '1.1rem' : '0.9rem'};
  font-weight: ${({ isTotal }) => isTotal ? '700' : '600'};
  color: ${({ isTotal }) => isTotal ? '#28a745' : '#333'};
`;

export const Divider = styled.hr`
  border: none;
  border-top: 1px solid #e9ecef;
  margin: 0;
`;

export const PaymentRow = styled.div`
  display: flex;
  gap: 16px;
  align-items: stretch;
`;

export const PaymentBlockPix = styled.div`
  flex: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  background: #fafafa;
`;

export const PaymentBlockBoleto = styled.div`
  flex: 8;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  background: #fafafa;
`;

export const PaymentBlockTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 1rem;
  font-weight: 600;
  color: #495057;
`;

export const QrCodeContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: 8px;
`;

export const QrCodeImage = styled.img`
  width: 100%;
  max-width: 120px;
  height: auto;
  border-radius: 6px;
  border: 1px solid #e0e0e0;
`;

export const BarcodeContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  width: 100%;
  overflow: hidden;
`;

export const BarcodeLabel = styled.span`
  font-size: 0.85rem;
  font-weight: 600;
  color: #495057;
`;

export const BarcodeValue = styled.span`
  font-size: 0.7rem;
  color: #777;
  word-break: break-all;
  text-align: center;
`;

export const ActionBar = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  padding: 16px;
  border-top: 1px solid #e0e0e0;
  background-color: #fafafa;
  flex-shrink: 0;
`;

export const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;
  gap: 12px;
`;

export const ErrorMessage = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background-color: #fee;
  border: 1px solid #fcc;
  border-radius: 4px;
  color: #c33;
  font-size: 0.875rem;
`;
